import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { partDetailsConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const PartDetailsStack = createStackNavigator();

const PartDetailsNavigator = () => {
  return (
    <PartDetailsStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {partDetailsConfig.map(({ Component, name }) => (
        <PartDetailsStack.Screen key={name} name={name} component={Component} />
      ))}
    </PartDetailsStack.Navigator>
  );
};

export { PartDetailsNavigator };
